export default __webpack_public_path__ + "static/media/grimacing-face.fea9c3ea.svg";